import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";

export const AdminLeadGrid = ({ leads }) => {

    const { SearchBar } = Search;

    const [readOnly, setReadOnly] = useState(true);
    const [counter, setCounter ] = React.useState(0);

    const editLead = (cell) => {
        return (
            <Link to={`/leadtub-admin-lead-details/${cell}`}>
                <Button onClick={() => setReadOnly(!readOnly)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        className="bi bi-pencil" viewBox="0 0 16 16">
                        <path
                            d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                    </svg>
                </Button>

            </Link>
        );
    }

    const displayStatus = (cell) => {
        switch (cell) {
            case true:
                return "Godkänd";
            case false:
                return "Ej Godkänd"
            default:
                return "Ej Behandlad"
        }
    }


    const displayDealStage = (cell) => {
        switch (cell) {
            case 'appointmentscheduled':
                return "Inkommen Lead";

            case 'qualifiedtobuy':
                return "Offert Skickad";
            case '41454020':
                return "Offert Öppnad";
            case '17878477':
                return "Offert Godkänd";
            case '17878478':
                return "Offert Nekad";
        }
    }
    const dateFormatter = (cell) => {

        if (cell) {
            return moment(cell.toDate()).format("YYYY-MM-DD")
        } else return <span>Inget datum</span>
    }



    const columns = [
        {
            dataField: 'reference',
            text: 'Reference:',
            sort: true,
            headerStyle: { textDecoration: 'underline', cursor: 'pointer' }
        },
        {
            dataField: "formInsertedAt",
            text: 'Inkommen vid ',
            sort: true,
            formatter: dateFormatter,
            headerStyle: { textDecoration: 'underline', cursor: 'pointer' }
        },
        {
            dataField: 'approved',
            text: 'Godkänd:',
            sort: true,
            formatter: displayStatus,

            headerStyle: { textDecoration: 'underline', cursor: 'pointer' }
        },
        {
            dataField: 'dealstage',
            text: 'dealstage',
            sort: true,
            formatter: displayDealStage,
            headerStyle: { textDecoration: 'underline', cursor: 'pointer' }

        },
        {
            dataField: 'estimatedBudget',
            text: 'Budget:',
            sort: true,
            headerStyle: { textDecoration: 'underline', cursor: 'pointer' }
        }, {
            dataField: 'company',
            text: 'Företag:',
            sort: true,
            headerStyle: () => {
                return { width: "5%", height: '5%' };
            }
        },
        {
            dataField: 'completed',
            text: 'Slutförd:',
            sort: true,
            headerStyle: { textDecoration: 'underline', cursor: 'pointer' }
        },
        {
            dataField: 'firstname',
            text: 'Förnamn:',
            sort: true,
            headerStyle: { textDecoration: 'underline', cursor: 'pointer' }
        },
        {
            dataField: 'lastname',
            text: 'Efternamn:',
            sort: true,
            headerStyle: { textDecoration: 'underline', cursor: 'pointer' }
        },
        {
            dataField: "id",
            text: "Redigera lead",
            formatter: editLead,
            sort: false
        },

    ];


    return (
        <Container fluid={"sm"} className={"leadsGrid"}>
            <Container>
                <h1>
                    Leads
                </h1>
                <p>
                    Antal leads i databasen: {leads.length}
                    <hr/>
                    Antal leads i databasen utan adminReference: {counter}

                </p>
            </Container>


            <ToolkitProvider
                keyField="id"
                data={leads}
                columns={columns}
                search
                condensed={true}
            >
                {props => (
                    <Container>
                        <SearchBar placeholder="Sök leads" srText={null}
                            className="SearchBar" {...props.searchProps} />
                        <BootstrapTable wrapperClasses="table-responsive" {...props.baseProps} />
                    </Container>
                )}
            </ToolkitProvider>
        </Container>
    )

}
